import $ from 'jquery';
import _ from 'underscore';
import { commaFormat, jqGetElemById, isMobile } from 'util/global';
import { errorModalHandler } from 'app/error_modal';

/** @module app/stats */
const stats = {};

/**
 * Handle clicking on and loading attempt data for individual days
 * @param {JQuery} $container
 */
stats.attemptPunchcard = function ($container) {
  const $clickableDays = $container.find('.clickable');
  const $attemptTable = jqGetElemById('attempt-table');
  const $attemptContent = jqGetElemById('attempt-table-content');
  const $attemptDate = jqGetElemById('attempt-table-date');
  const $b2Button = $attemptTable.find('.btn');
  const tmpl = _.template(jqGetElemById('attempt-table-row').text());
  let existingRequest = null;

  if (isMobile) {
    $container.find('.calendar').scrollLeft(1500);
  }

  if ($clickableDays.length === 0) {
    jqGetElemById('stat-punchard-nodata').show();
    return;
  }

  $clickableDays.on('click', function (e) {
    var $this = $(this);
    if (!$this.hasClass('active')) {
      var data = $this.data();

      if (existingRequest !== null) {
        existingRequest.abort();
      }

      $clickableDays.removeClass('active');
      $this.addClass('active');

      $b2Button.addClass('hide');
      $attemptTable.removeClass('hide');
      $attemptContent.html('<tr><td colspan="4"><span class="spinner"></span></td></tr>');
      $attemptDate.text(data.date);

      existingRequest = $.ajax({ url: data.details });
      existingRequest.fail(errorModalHandler).then(response => {
        existingRequest = null;
        const html = response.details
          .map(detail => {
            detail.r = commaFormat(detail.r);
            return tmpl(detail);
          })
          .join('');
        $attemptContent.html(html);
        $b2Button.removeClass('hide');
      });
    }
  });
};

module.exports = stats;
